import Vue from "vue";
import Router from "vue-router";
import userRoutes from "./user";
import Home from "@/views/home";
import Search from "@/views/search";
import Detail from "@/views/detail";
//import events from "@/views/events";
import gfMoney from "@/views/gfMoney";
import chouJiang from "@/views/choujiang";
import UserProtocol from "@/views/userProtocol";
import ImgRules from "@/views/imgRules";
import member from "@/views/member.vue";
import memberLogined from '@/views/memberLogined.vue'

Vue.use(Router);

export default new Router({
  // mode: 'history', // require service support
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: "/home", component: Home },
    {
      path: "/search",
      component: Search,
    },
    {
      path: "/gfMoney",
      component: gfMoney,
    },
    {
      path: "/lucky",
      component: chouJiang,
    },
    {
      path: "/detail",
      component: Detail,
    },
    {
      path: "/protocol/upload",
      component: UserProtocol,
    },
    {
      path: "/protocol/img",
      component: ImgRules,
    },
    {
      path: "/member",
      component: member,
      
    },
    {
      path: "/memberLogined",
      component: memberLogined,
    },
    {
      path: '*', // 匹配所有路径
      redirect: '/home'
    },
    ...userRoutes,
  ],
});
